import script from "./TransactionConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionConfirmDialog.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionConfirmDialog.vue?vue&type=style&index=0&id=620c2251&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-620c2251"]])

export default __exports__